import { memo } from 'react'
import { MapContainer, TileLayer, useMapEvents, Marker } from 'react-leaflet'

/**
 * Component to handle map clicks and place marker
 */
function LocationMarker({ position, setPosition }) {
  useMapEvents({
    click(e) {
      setPosition(e.latlng)
    },
  })

  return position === null ? null : <Marker position={position} />
}

/**
 * Interactive map for location selection
 * Allows users to click to set a marker position
 */
const LocationPickerMap = memo(function LocationPickerMap({
  userLocation,
  position,
  setPosition,
  height = '500px',
  zoom = 17
}) {
  if (!userLocation) {
    return (
      <div 
        className="flex items-center justify-center bg-gray-50 rounded-lg border-2 border-gray-200"
        style={{ height }}
      >
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-primary mb-2"></div>
          <p className="text-sm text-gray-600">Loading map...</p>
        </div>
      </div>
    )
  }

  return (
    <div className="rounded-lg overflow-hidden border-2 border-primary-200 shadow-lg" style={{ height }}>
      <MapContainer
        key={`location-picker-${userLocation[0]}-${userLocation[1]}`}
        center={userLocation}
        zoom={zoom}
        style={{ height: '100%', width: '100%' }}
        className="leaflet-container-custom"
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          maxZoom={19}
          minZoom={3}
        />
        <LocationMarker position={position} setPosition={setPosition} />
      </MapContainer>
    </div>
  )
})

export default LocationPickerMap
